import { useTranslation } from 'react-i18next';
import { MessageSquare } from 'lucide-react';
import { cn, IconButton } from '../../ui';
import { Icon } from '../../ui/icons';

/**
 * Opens the comments panel (backlog §19 P16-3.2): an icon with the number of open threads, hidden at zero, in the
 * accent colour when a mention or a reply concerns me. The badge keeps its room when hidden: the bar never shifts.
 */
export function CommentsButton({ count, mention = false, open, onToggle, docked = false }: { count: number; mention?: boolean; open: boolean; onToggle: () => void; docked?: boolean }) {
  const { t } = useTranslation();
  const label = count === 0 ? t('comments.open') : t(mention ? 'comments.buttonMention' : 'comments.buttonCount', { count });
  return (
    <span className={cn('relative inline-flex', !docked && 'absolute right-3 top-14 z-20 rounded-lg bg-surface shadow-md')}>
      <IconButton label={label} pressed={open} onClick={onToggle} icon={<Icon icon={MessageSquare} size={16} />} className="aria-pressed:bg-accent-soft aria-pressed:text-accent" />
      <span
        aria-hidden="true"
        data-badge={count === 0 ? 'hidden' : mention ? 'mention' : 'count'}
        className={cn(
          'pointer-events-none absolute -right-1 -top-1 min-w-4 rounded-full px-1 text-center font-mono text-[10px] font-semibold leading-4',
          mention ? 'bg-accent text-accent-fg' : 'bg-surface-2 text-fg shadow-sm',
          count === 0 && 'invisible',
        )}
      >
        {count > 9 ? '9+' : count || '0'}
      </span>
    </span>
  );
}
